module.exports = __webpack_public_path__ + "media/images/download/e-book15-0f715256dac26cb37ea9e4e052d767a2.png";